import { render, staticRenderFns } from "./TituloNotasParciais.vue?vue&type=template&id=56e2152c&"
import script from "./TituloNotasParciais.vue?vue&type=script&lang=js&"
export * from "./TituloNotasParciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports